import { HttpClient } from '@angular/common/http';
import { Component, Input, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../environments/environment';
import { AlertService } from '../alert.service';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'tea-shop-fe-subscribe-block',
    templateUrl: './subscribe-block.component.html',
    styleUrl: './subscribe-block.component.css',
    imports: [ReactiveFormsModule],
})
export class SubscribeBlockComponent {
  private readonly httpClient = inject(HttpClient);
  private formBuilder = inject(FormBuilder);
  private alertService = inject(AlertService);
  private logger = inject(NGXLogger);

  @Input() buttonClasses = 'bg-green-600 text-white px-4 py-2 rounded w-full hover:bg-green-700';
  subscribeForm: FormGroup;
  isSubmitting = false;

  private readonly endpoint = `${environment.apiHost ?? ''}/api/communications/newsletter/subscribe`;

  constructor() {
    this.subscribeForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit() {
    if (this.subscribeForm.invalid) return;
    
    this.isSubmitting = true;
    this.subscribe(this.subscribeForm.value.email).subscribe({
      next: (result) => {
        this.logger.log('Subscribed successfully', result);
        this.subscribeForm.reset();
        this.isSubmitting = false;
        this.alertService.show({
          title: 'Subscribed: The First Steep',
          description: 'You have successfully subscribed to The First Steep digest.',
          type: 'success',
        })
      },
      error: (error: any) => {
        this.logger.log('Subscription failed', error);
        this.isSubmitting = false;
        this.alertService.show({
          title: 'Subscription Failed',
          description: 'There was a problem subscribing you to The First Steep digest. Please try again later.',
          type: 'warning',
        });
      }
    });
  }

  subscribe(email: string) {
    this.logger.log('Subscribing to defauly mailing list', email);
    return this.httpClient.post(this.endpoint, { email });
  }
}
